export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/upload-payment-icon.8ca6ebbf.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};